import * as Yup from 'yup';

interface NameSchemaOptions {
  required?: boolean;
  requiredMessage?: string;
}

interface EmailSchemaOptions {
  required?: boolean;
  requiredMessage?: string;
}

interface PhoneSchemaOptions {
  required?: boolean;
  requiredMessage?: string;
}

interface PasswordSchemaOptions {
  required?: boolean;
  requiredMessage?: string;
  minLength?: number;
  minLengthMessage?: string;
}

interface PasswordMatchSchemaOptions {
  required?: boolean;
  requiredMessage?: string;
  message?: string;
}

export function nameSchema(options: NameSchemaOptions = {}) {
  const { required = false, requiredMessage = 'Bu alan zorunludur' } = options;
  let schema = Yup.string().trim();
  if (required) {
    schema = schema.required(requiredMessage);
  }
  return schema;
}

export function emailSchema(options: EmailSchemaOptions = {}) {
  const { required = false, requiredMessage = 'E-posta zorunludur' } = options;
  let schema = Yup.string().trim().email('Geçerli bir e-posta adresi giriniz');
  if (required) {
    schema = schema.required(requiredMessage);
  }
  return schema;
}

export function phoneSchema(options: PhoneSchemaOptions = {}) {
  const { required = false, requiredMessage = 'Telefon numarası zorunludur' } = options;
  let schema = Yup.string().trim();
  if (required) {
    schema = schema.required(requiredMessage);
  }
  return schema;
}

export function passwordSchema(options: PasswordSchemaOptions = {}) {
  const {
    required = false,
    requiredMessage = 'Şifre zorunludur',
    minLength,
    minLengthMessage = 'Şifre en az 6 karakter olmalı',
  } = options;
  let schema = Yup.string();
  if (required) {
    schema = schema.required(requiredMessage);
  }
  if (minLength !== undefined) {
    schema = schema.min(minLength, minLengthMessage);
  }
  return schema;
}

export function passwordMatchSchema(
  fieldRef: string,
  options: PasswordMatchSchemaOptions = {}
) {
  const {
    required = false,
    requiredMessage = 'Şifre tekrarı zorunludur',
    message = 'Şifreler eşleşmiyor',
  } = options;
  let schema = Yup.string().oneOf([Yup.ref(fieldRef)], message);
  if (required) {
    schema = schema.required(requiredMessage);
  }
  return schema;
}
